import { useState } from 'react'
import { CheckCircle2 } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'
import { Label } from '@/components/ui/label'

interface ApproveRecordDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: (comment?: string) => Promise<void>
  isLoading: boolean
}

export function ApproveRecordDialog({ open, onClose, onConfirm, isLoading }: ApproveRecordDialogProps) {
  const [comment, setComment] = useState('')

  const handleConfirm = async () => {
    await onConfirm(comment || undefined)
    setComment('')
  }

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CheckCircle2 className="w-5 h-5 text-emerald-400" />
            تأیید سابقه؟
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          با تأیید این سابقه، وضعیت آن به «تأیید شده» تغییر می‌یابد و به ثبت‌کننده اطلاع داده می‌شود.
        </p>
        <div className="space-y-2">
          <Label className="text-sm">نظر تأیید (اختیاری)</Label>
          <Textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="می‌توانید یک نظر کلی برای ثبت‌کننده بنویسید..."
            rows={3}
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>انصراف</Button>
          <Button
            onClick={handleConfirm}
            disabled={isLoading}
            className="bg-emerald-600 hover:bg-emerald-700 text-white"
          >
            {isLoading ? 'در حال تأیید...' : 'تأیید سابقه'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
